var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Speaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 38a36.53 36.53 0 01-9 24.07l-3-2.63a32.58 32.58 0 000-42.88l3-2.63A36.53 36.53 0 0164 38zM50.36 20.34l-3.16 2.44a24.95 24.95 0 010 30.44l3.16 2.44a28.91 28.91 0 000-35.32zm-3.36 8l-3.58 1.77a17.88 17.88 0 010 15.76L47 47.65a21.82 21.82 0 000-19.3v-.01zM19.79 31L38 15.58V60L19.07 46H15a4 4 0 01-4-4v-7a4 4 0 014-4h4.79zM23 44l11 8.13V24.25l-11 9.3V44z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Speaker.f2ecb27c.svg";
export { SvgH1Speaker as ReactComponent };